import { format, parseISO } from "date-fns";
import React from "react";

import tagminWhiteOnMulticolourPng from "../../../../assets/images/tagmin-white-on-multicolour.png";
import { ActionButton } from "component-library";
import type { IUnavailableDates } from "models/AvailabilityCalendar";

interface IAvailabilityCalendarRowProps {
  data: IUnavailableDates;
  onClickDelete: (id: string) => void;
}

const AvailabilityCalendarRow = ({
  data,
  onClickDelete,
}: IAvailabilityCalendarRowProps) => {
  const { id, startDate, endDate, title, externalShared } = data;

  const formatDate = (date: string) => {
    const dateObj = parseISO(date);
    return format(dateObj, "dd MMM, yyyy");
  };

  return (
    <div
      key={id}
      className="flex justify-between align-middle gap-2 bg-color-neutral-three p-2.5"
    >
      <div className="flex flex-col md:flex-row md:gap-0.5">
        <span className="m-0 font-semibold">
          {formatDate(startDate)} - {formatDate(endDate)}:
        </span>
        <span>{title}</span>
      </div>
      <div className="flex items-center md:gap-2">
        {externalShared ? (
          <img
            src={tagminWhiteOnMulticolourPng}
            alt="Tagmin sync enabled"
            className="object-contain"
          />
        ) : null}
        <ActionButton
          ariaLabel="delete"
          icon="delete"
          onClick={() => onClickDelete(id)}
          size="xs"
        />
      </div>
    </div>
  );
};

export default AvailabilityCalendarRow;
